import LikeIcon from "./LikeIcon";
import CrossIcon from "./CrossIcon";
import VerifiedBadge from "./VerifiedBadge";
import Notification from "./Notification";
import Filter from "./Filter";
import CloseEmpty from "./CloseEmpty";
import WhiteClose from "./WhiteClose";
import Star from "./Star";
import FrontArrow from "./FrontArrow";
import BackIcon from "./BackIcon";
import CurrentLocation from "./CurrentLocation";
import Lock from "./Lock";
import TickCircle from "./TickCircle";
import ComingSoon from "./ComingSoon";
import MainHomeScreenIcon from "./MainScreenIcon";
import Stars from "./Stars";
import Tick from "./Tick";
const FeedIcons = {
  LikeIcon,ComingSoon,
  MainHomeScreenIcon,
  CrossIcon,
  Stars,
  TickCircle,
  Tick,
  Lock,
  VerifiedBadge,
  CurrentLocation,
  Notification,
  Filter,
  CloseEmpty,
  FrontArrow,
  WhiteClose,
  Star,
  BackIcon,
};

export default FeedIcons;
